import { CardContent, Grid, Paper, Typography, Box } from '@material-ui/core';
import React from 'react';
import {
  CheckBoxFastField,
  TextFieldFastField,
  UnitOfMeasurementsFastField,
  Image,
} from '../../../components';

import holePositionSingleImg from './images/single.png';
import holePositionDoubleImg from './images/double.png';
import holePositionFoldImg from './images/fold.png';
import holePositionDistanceImg from './images/distance.png';

interface SampleDevelopmentHlAssemblyProps {
  isCrtLocked?: boolean;
}

const SampleDevelopmentHlAssembly: React.FC<SampleDevelopmentHlAssemblyProps> = (
  props,
) => {
  const { isCrtLocked = false } = props;

  return (
    <Box m={1}>
      <Paper variant="outlined">
        <CardContent>
          <Grid
            container
            spacing={1}
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            item
            xs={12}
          >
            <Grid item xs={12}>
              <Typography>HL Assembly</Typography>
            </Grid>
            <Grid item xs={12} md={2}>
              <Typography>เข้าเล่ม(Binding): </Typography>
            </Grid>
            <Grid item xs={12} md={2}>
              <CheckBoxFastField
                disabled={isCrtLocked}
                name="bindingFold"
                label="พับ(Fold)"
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <CheckBoxFastField
                disabled={isCrtLocked}
                name="bindingTransparent"
                label="ใส(Transparent)"
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <CheckBoxFastField
                disabled={isCrtLocked}
                name="bindingStaples"
                label="ลวดเย็บ(Staples)"
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <TextFieldFastField
                disabled={isCrtLocked}
                name="bindingStaplesData"
                label="ลวดเย็บ(Staples)"
                variant="outlined"
                margin="dense"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={2} />
            <Grid item xs={12} md={2}>
              <Typography>ปะ(Gluing): </Typography>
            </Grid>
            <Grid item xs={12} md={2}>
              <CheckBoxFastField
                disabled={isCrtLocked}
                name="gluingLaminate"
                label="ปะกบ(Laminate)"
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <CheckBoxFastField
                disabled={isCrtLocked}
                name="gluingSleeve"
                label="ปะซอง(Sleeve)"
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <CheckBoxFastField
                disabled={isCrtLocked}
                name="gluingGlue"
                label="ปะกาว(Glue)"
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <TextFieldFastField
                disabled={isCrtLocked}
                name="adhesiveTapeDesc"
                label="ปะกาว(Glue)"
                variant="outlined"
                margin="dense"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <CheckBoxFastField
                disabled={isCrtLocked}
                name="gluingBag"
                label="ปะถุง(Bag)"
              />
            </Grid>
            <Grid item xs={12} md={2} />
            <Grid item xs={12} md={2}>
              <CheckBoxFastField
                disabled={isCrtLocked}
                name="gluingBox"
                label="ปะลิ้นกล่อง(Box)"
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <CheckBoxFastField
                disabled={isCrtLocked}
                name="gluingWindowPlastic"
                label="ปะหน้าต่างพลาสติก(Window Plastic)"
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <CheckBoxFastField
                disabled={isCrtLocked}
                name="gluingDoubleSidedTape"
                label="ปะเทป 2 หน้า(Double Sided Tape)"
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <TextFieldFastField
                disabled={isCrtLocked}
                name="gluingDoubleSidedTapeData"
                label="Double Sided Tape"
                variant="outlined"
                margin="dense"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={2}></Grid>
            <Grid item xs={12} md={2}></Grid>
            <Grid item xs={12} md={2}>
              <CheckBoxFastField
                disabled={isCrtLocked}
                name="gluingCorrugatedLaminate"
                label="ปะลูกฟูก(Corrugated Laminate)"
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <TextFieldFastField
                disabled={isCrtLocked}
                name="gluingCorrugatedLaminateData"
                label="Corrugated Laminate"
                variant="outlined"
                margin="dense"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <CheckBoxFastField
                disabled={isCrtLocked}
                name="gluingCamshell"
                label="Camshell"
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <TextFieldFastField
                disabled={isCrtLocked}
                name="gluingCamshellData"
                label="Camshell"
                variant="outlined"
                margin="dense"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={2}></Grid>
            <Grid item xs={12} md={2}></Grid>
            <Grid item xs={12} md={2}>
              <CheckBoxFastField
                disabled={isCrtLocked}
                name="gluingFoam"
                label="โฟม(Foam)"
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <TextFieldFastField
                disabled={isCrtLocked}
                name="gluingFoamData"
                label="Foam"
                variant="outlined"
                margin="dense"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={6} />
            <Grid item xs={12} md={2}>
              <Typography>ร้อยเชือก(String):</Typography>
            </Grid>
            <Grid item xs={12} md={2}>
              <CheckBoxFastField
                disabled={isCrtLocked}
                name="stringSingle"
                label="เดี่ยว(Single)"
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <CheckBoxFastField
                disabled={isCrtLocked}
                name="stringDouble"
                label="คู่(Double)"
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <CheckBoxFastField
                disabled={isCrtLocked}
                name="stringOther"
                label="อื่นๆ(Other)"
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <TextFieldFastField
                disabled={isCrtLocked}
                name="stringOtherData"
                label="อื่นๆ(Other)"
                variant="outlined"
                margin="dense"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={2} />
            <Grid item xs={12} md={2} />
            <Grid item xs={12} md={2}>
              <TextFieldFastField
                disabled={isCrtLocked}
                name="stringType"
                label="ชนิด(Type)"
                variant="outlined"
                margin="dense"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <TextFieldFastField
                disabled={isCrtLocked}
                name="stringSize"
                label="ขนาด(Size)"
                variant="outlined"
                margin="dense"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <TextFieldFastField
                disabled={isCrtLocked}
                name="stringColor"
                label="สี(Color)"
                variant="outlined"
                margin="dense"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <TextFieldFastField
                disabled={isCrtLocked}
                type="number"
                step="any"
                name="stringLengthKnot"
                label="ความยาวถึงปม(Length Knot)"
                variant="outlined"
                margin="dense"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <UnitOfMeasurementsFastField
                disabled={isCrtLocked}
                name="stringLengthKnotUnit"
                label="Unit"
              />
            </Grid>
            <Grid item xs={12} md={2} />
            <Grid item xs={12} md={2}>
              <TextFieldFastField
                disabled={isCrtLocked}
                type="number"
                step="any"
                name="stringLengthEnd"
                label="ความยาวปมถึงปลาย(Length End)"
                variant="outlined"
                margin="dense"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <UnitOfMeasurementsFastField
                disabled={isCrtLocked}
                name="stringLengthEndUnit"
                label="Unit"
              />
            </Grid>
            <Grid item xs={12} md={6} />
            <Grid item xs={12} md={2}>
              <Typography>เข็มกลัด(Pin): </Typography>
            </Grid>
            <Grid item xs={12} md={2}>
              <TextFieldFastField
                disabled={isCrtLocked}
                name="pinType"
                label="ชนิด(Type)"
                variant="outlined"
                margin="dense"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <TextFieldFastField
                disabled={isCrtLocked}
                name="pinSize"
                label="ขนาด(Size)"
                variant="outlined"
                margin="dense"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <TextFieldFastField
                disabled={isCrtLocked}
                name="pinColor"
                label="สี(Color)"
                variant="outlined"
                margin="dense"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={4} />
            <Grid item xs={12} md={2}>
              <Typography>รู(Hole): </Typography>
            </Grid>
            <Grid item xs={12} md={2}>
              <CheckBoxFastField
                disabled={isCrtLocked}
                name="holeSingle"
                label="เดี่ยว(Single)"
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <CheckBoxFastField
                disabled={isCrtLocked}
                name="holeDouble"
                label="คู่(Double)"
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <CheckBoxFastField
                disabled={isCrtLocked}
                name="holeOther"
                label="อื่นๆ(Other)"
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <TextFieldFastField
                disabled={isCrtLocked}
                name="holeOtherData"
                label="อื่นๆ(Other)"
                variant="outlined"
                margin="dense"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={2} />
            <Grid item xs={12} md={2} />
            <Grid item xs={12} md={2}>
              <TextFieldFastField
                disabled={isCrtLocked}
                type="number"
                step="any"
                name="holeSize"
                label="ขนาด(Size)"
                variant="outlined"
                margin="dense"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <UnitOfMeasurementsFastField
                disabled={isCrtLocked}
                name="holeSizeUnit"
                label="Unit"
              />
            </Grid>
            <Grid item xs={12} md={6} />
            <Grid item xs={12} md={2}>
              <Typography>ตำแหน่งรู(Hole Position): </Typography>
            </Grid>
            <Grid item xs={12} md={2}>
              <CheckBoxFastField
                disabled={isCrtLocked}
                name="holePositionSingle"
                label="เดี่ยว(Single)"
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <Image width="100px" src={holePositionSingleImg} alt="เดี่ยว(Single)" />
            </Grid>
            <Grid item xs={12} md={2}>
              <TextFieldFastField
                disabled={isCrtLocked}
                type="number"
                step="any"
                min="1"
                max="8"
                name="holePositionSingleNum"
                label="เดี่ยว(Single)"
                variant="outlined"
                margin="dense"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={4} />
            <Grid item xs={12} md={2} />
            <Grid item xs={12} md={2}>
              <CheckBoxFastField
                disabled={isCrtLocked}
                name="holePositionDouble"
                label="คู่(Double)"
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <Image width="100px" src={holePositionDoubleImg} alt="คู่(Double)" />
            </Grid>
            <Grid item xs={12} md={2}>
              <TextFieldFastField
                disabled={isCrtLocked}
                type="number"
                step="any"
                min="1"
                max="8"
                name="holePositionDoubleNum"
                label="คู่(Double)"
                variant="outlined"
                margin="dense"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={4} />
            <Grid item xs={12} md={2} />
            <Grid item xs={12} md={2}>
              <CheckBoxFastField
                disabled={isCrtLocked}
                name="holePositionFold"
                label="พับทบ(Fold)"
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <Image width="100px" src={holePositionFoldImg} alt="พับทบ(Fold)" />
            </Grid>
            <Grid item xs={12} md={2}>
              <TextFieldFastField
                disabled={isCrtLocked}
                type="number"
                step="any"
                min="1"
                max="8"
                name="holePositionFoldNum"
                label="พับทบ(Fold)"
                variant="outlined"
                margin="dense"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={4} />
            <Grid item xs={12} md={2} />
            <Grid item xs={12} md={2}>
              <Image
                width="100px"
                src={holePositionDistanceImg}
                alt="ระยะห่างจากแกน(Distance)"
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <TextFieldFastField
                disabled={isCrtLocked}
                type="number"
                step="any"
                name="holePositionDistanceX"
                label="ระยะห่างจากแกน X(Distance X)"
                variant="outlined"
                margin="dense"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={1}>
              <UnitOfMeasurementsFastField
                disabled={isCrtLocked}
                name="holePositionDistanceXUnit"
                label="Unit"
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <TextFieldFastField
                disabled={isCrtLocked}
                type="number"
                step="any"
                name="holePositionDistanceY"
                label="ระยะห่างจากแกน Y(Distance Y)"
                variant="outlined"
                margin="dense"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={1}>
              <UnitOfMeasurementsFastField
                disabled={isCrtLocked}
                name="holePositionDistanceYUnit"
                label="Unit"
              />
            </Grid>
            <Grid item xs={12} md={2} />
            <Grid item xs={12} md={2}>
              <Typography>ตาไก่(Eyelet): </Typography>
            </Grid>
            <Grid item xs={12} md={2}>
              <CheckBoxFastField
                disabled={isCrtLocked}
                name="eyeletNickleFree"
                label="ไร้สาร(Nickle Free)"
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <CheckBoxFastField
                disabled={isCrtLocked}
                name="eyeletRustness"
                label="ไร้สนิม(Rustness)"
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <CheckBoxFastField
                disabled={isCrtLocked}
                name="eyeletPlain"
                label="ธรรมดา(Plain)"
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <TextFieldFastField
                disabled={isCrtLocked}
                name="eyeletType"
                label="ชนิด(Type)"
                variant="outlined"
                margin="dense"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <TextFieldFastField
                disabled={isCrtLocked}
                name="eyeletSize"
                label="ขนาด(Size)"
                variant="outlined"
                margin="dense"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={2} />
            <Grid item xs={12} md={2}>
              <TextFieldFastField
                disabled={isCrtLocked}
                name="eyeletColor"
                label="สี(Color)"
                variant="outlined"
                margin="dense"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={8} />
            <Grid item xs={12} md={2}>
              <Typography>การเปลี่ยนแปลง(Variable): </Typography>
            </Grid>
            <Grid item xs={12} md={2}>
              <TextFieldFastField
                disabled={isCrtLocked}
                type="number"
                step="any"
                name="variableAmount"
                label="จำนวน(Amount)"
                variant="outlined"
                margin="dense"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={8}></Grid>
            <Grid item xs={12} md={2}></Grid>
            <Grid item xs={12} md={10}>
              <TextFieldFastField
                disabled={isCrtLocked}
                name="variableOtherData"
                label="Other"
                variant="outlined"
                margin="dense"
                fullWidth
                multiline={true}
                rows={3}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <Typography>Packing: </Typography>
            </Grid>
            <Grid item xs={12} md={2}>
              <CheckBoxFastField
                disabled={isCrtLocked}
                name="packingPlain"
                label="มาตราฐาน (Standard)"
              />
            </Grid>
            <Grid item xs={12} md={8} />
            <Grid item xs={12} md={12}>
              <TextFieldFastField
                disabled={isCrtLocked}
                name="specialInstruction"
                label="Special Instruction"
                variant="outlined"
                margin="dense"
                fullWidth
              />
            </Grid>
          </Grid>
        </CardContent>
      </Paper>
    </Box>
  );
};

export default SampleDevelopmentHlAssembly;
